module.exports = __webpack_public_path__ + "static/media/augmented.c4556e54.svg";